interface Props {
  size?: number;
  color?: string;
}

const TransactionIcon = (props: Props) => {
  const { color = '#000', size = 25 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox={`0 0 ${size} ${size}`}
    >
      <path
        fill={color}
        stroke={color}
        strokeWidth="0.5"
        d="M20.732 2.253h-10a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3Zm1 10a1 1 0 0 1-1 1h-10a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1zm-3.5-4a1.5 1.5 0 0 0-1 .39 1.5 1.5 0 1 0 0 2.22 1.501 1.501 0 1 0 1-2.61Zm-1.5 9a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1h-10a1 1 0 0 1-1-1v-4h1a1 1 0 0 0 0-2h-1v-1a1 1 0 0 1 1-1 1 1 0 0 0 0-2 3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1a1 1 0 0 0-1-1Zm-10 1h1a1 1 0 0 0 0-2h-1a1 1 0 1 0 0 2Z"
      ></path>
    </svg>
  );
};

export default TransactionIcon;
